import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api } from '../api/http.js';
import { tEnum, locale } from '../i18n/index.js';

/* Словари домена приходят с сервера: подписи статусов и состояний живут
   в одном месте. Иначе новый статус появится в API и не появится
   в интерфейсе — или разойдётся формулировка. */
export const useMetaStore = defineStore('meta', () => {
  const data = ref(null);
  const loading = ref(false);
  let inflight = null;

  async function load() {
    if (data.value) return data.value;
    if (inflight) return inflight;
    loading.value = true;
    inflight = api.get('/meta')
      .then((d) => { data.value = d; return d; })
      .finally(() => { loading.value = false; inflight = null; });
    return inflight;
  }

  /* Подпись с запасным вариантом: показать код лучше, чем пустоту.

     Перевод накладывается поверх серверной подписи, а не заменяет её.
     Сервер остаётся одним местом правды про домен: новый статус, добавленный
     в API, сразу виден в интерфейсе — пусть и по-русски, — а не исчезает
     до того, как кто-то допишет словарь.

     Чтение locale.value здесь не лишнее: без него computed в шаблонах
     не пересчитается при смене языка, и подписи останутся прежними
     до перезагрузки страницы. */
  const label = (group, key) => {
    locale.value;
    const серверная = data.value?.[group]?.labels?.[key];
    return tEnum(group, key, серверная ?? key ?? '');
  };

  const orderStatus = (k) => label('orderStatus', k);
  const opStatus = (k) => label('opStatus', k);
  const equipmentState = (k) => label('equipmentState', k);
  const orderOrigin = (k) => label('orderOrigin', k);
  const outputKind = (k) => label('outputKind', k);
  const roleName = (k) => label('role', k);

  const transitionsFor = (status) => data.value?.orderStatus?.transitions?.[status] || [];
  const rolesForStatus = (status) => data.value?.orderStatus?.roles?.[status] || [];

  return { data, loading, load, label, orderStatus, opStatus, equipmentState, orderOrigin, outputKind, roleName,
    transitionsFor, rolesForStatus };
});

/* Цвет — оформление, поэтому живёт на клиенте, а не в API.
   Токены меняются вместе с темой, поэтому карточка одинаково читается в обеих. */
export const STATE_COLOR = {
  run: 'var(--st-run)',
  idle: 'var(--st-idle)',
  maint: 'var(--st-maint)',
  down: 'var(--st-down)',
  off: 'var(--st-off)',
};

export const ORDER_STATUS_COLOR = {
  draft: 'var(--t3)',
  pending: 'var(--st-maint)',
  approved: 'var(--st-idle)',
  planned: 'var(--st-idle)',
  released: 'var(--accent)',
  run: 'var(--st-run)',
  paused: 'var(--st-maint)',
  done: 'var(--st-run)',
  closed: 'var(--t3)',
  cancelled: 'var(--st-down)',
};

export const OP_STATUS_COLOR = {
  wait: 'var(--t3)',
  active: 'var(--st-run)',
  paused: 'var(--st-maint)',
  done: 'var(--st-run)',
  skipped: 'var(--t3)',
};
